function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo, createContext, useContext } from 'react';
import { DeviceProvider as SeagullDeviceProvider } from 'seagull';
import { jsx as _jsx } from "react/jsx-runtime";
const RootDeviceContext = /*#__PURE__*/createContext({
  isMobileDevice: false
});
export function RootDeviceProvider(_ref) {
  let {
    children,
    isMobileDevice
  } = _ref;
  const value = useMemo(() => ({
    isMobileDevice
  }), [isMobileDevice]);
  return /*#__PURE__*/_jsx(RootDeviceContext.Provider, {
    value: value,
    children: children
  });
}
export const useRootDevice = () => useContext(RootDeviceContext);
export function withDeviceProvider(Component) {
  return function WithDeviceProvider(props) {
    const {
      isMobileDevice
    } = useRootDevice();
    const value = useMemo(() => ({
      isMobileDevice
    }), [isMobileDevice]);
    return /*#__PURE__*/_jsx(SeagullDeviceProvider, {
      value: value,
      children: /*#__PURE__*/_jsx(Component, _objectSpread({}, props))
    });
  };
}